import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer>
        <span className="footer-brand">
          Dreams From Our Founding Fathers
        </span>

        <span className="footer-copy">
          America's 250th Anniversary · 1776–2026 · Ron DeSantis · Limited to
          1,776 Copies
        </span>

        <div className="footer-links">
          <Link className="footer-link" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className="footer-link" to="/refund-policy">
            Refund Policy
          </Link>
          <Link className="footer-link" to="/terms-and-conditions">
            Terms & Conditions
          </Link>
        </div>

      </footer>
    </>
  );
};

export default Footer;
